import React from 'react';
import PropTypes from 'prop-types';

const PLAYING = 'playing';
const PAUSED = 'paused';

class MobilePlayerControl extends React.Component {

  state = {
    playerState: PLAYING
  }

  static getDerivedStateFromProps(props) {
    if(!props.player) {
      return null;
    }

    if (!props.player.isPlaying) {
      return null;
    }

    return {
      playerState: props.player.isPlaying() ? PLAYING : PAUSED
    }
  }

  componentDidUpdate() {
    if (this.props.player && this.props.player.mb && !this.subscribed) {
      this.props.player.mb.subscribe('paused', '', () => { this.setState({playerState: PAUSED}) });
      this.props.player.mb.subscribe('playing', '', () => { this.setState({playerState: PLAYING}) });
      this.subscribed = true;
    }
  }


  pause = () => {
    this.props.player.pause();
    this.setState({playerState: PAUSED})
  }

  play = () => {
    this.props.player.play();
    this.setState({playerState: PLAYING})
  }

  getPlayerIcon = () => {
    switch (this.state.playerState) {
      case PLAYING:
        return <img className="control-button-mobile" onClick={this.pause} src="/img/icons/ooyala/pause-icon.svg"/>
      case PAUSED:
        return <img className="control-button-mobile" onClick={this.play} src="/img/icons/ooyala/play-icon.svg"/>
      default:
        return null
    }
  }

  render() {
    return (
      <div>
        {this.getPlayerIcon()}
      </div>
    )
  }
}

MobilePlayerControl.propTypes = {
  player: PropTypes.shape({
    play: PropTypes.func,
    pause: PropTypes.func,
    mb: PropTypes.shape({
      subscribe: PropTypes.func
    })
  })
}

export default MobilePlayerControl;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/MobilePlayerControl.js